import axios from "axios";
import Config from "../../../config/index";
import {
  GET_CHEMICAL_ANALYSIS_REQUEST,
  GET_CHEMICAL_ANALYSIS_SUCCESS,
  GET_CHEMICAL_ANALYSIS_FAILURE,
  DELETE_CHEMICAL_ANALYSIS_REQUEST,
  DELETE_CHEMICAL_ANALYSIS_SUCCESS,
  DELETE_CHEMICAL_ANALYSIS_FAILURE,
  CREATE_CHEMICAL_ANALYSIS_REQUEST,
  CREATE_CHEMICAL_ANALYSIS_SUCCESS,
  CREATE_CHEMICAL_ANALYSIS_FAILURE,
  EDIT_CHEMICAL_ANALYSIS_REQUEST,
  EDIT_CHEMICAL_ANALYSIS_SUCCESS,
  EDIT_CHEMICAL_ANALYSIS_FAILURE,

   
  UPLOADCSV_CHEMICAL_ANALYSIS_REQUEST,
  UPLOADCSV_CHEMICAL_ANALYSIS_SUCCESS,
  UPLOADCSV_CHEMICAL_ANALYSIS_FAILURE,
} from "./chemicalAnalysisTypes";

let baseUrl = Config.baseUrl;
let baseUrlFileUploadTemp = Config.baseUrlFileUploadTemp;

// --- GET API ---
const getChemicalAnalysisRequest = () => ({
  type: GET_CHEMICAL_ANALYSIS_REQUEST,
});
const getChemicalAnalysisSuccess = (payload) => ({
  type: GET_CHEMICAL_ANALYSIS_SUCCESS,
  payload,
});
const getChemicalAnalysisFailure = (error) => ({
  type: GET_CHEMICAL_ANALYSIS_FAILURE,
  payload: error,
});

const getChemicalAnalysis = (dppId, jwtToken) => {
  let headers = { headers: { Authorization: `Bearer ${jwtToken}` } };

  return (dispatch) => {
    dispatch(getChemicalAnalysisRequest());

    let url = dppId
      ? `${baseUrl}/dpp/chemical_analysis/get_dpp?dppId=${dppId}`
      : `${baseUrl}/dpp/chemical_analysis/get_all`;

    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getChemicalAnalysisSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getChemicalAnalysisFailure(err.message));
      });
  };
};

// --- DELETE API ---
const deleteChemicalAnalysisRequest = () => ({
  type: DELETE_CHEMICAL_ANALYSIS_REQUEST,
});
const deleteChemicalAnalysisSuccess = (payload) => ({
  type: DELETE_CHEMICAL_ANALYSIS_SUCCESS,
  payload,
});
const deleteChemicalAnalysisFailure = (error) => ({
  type: DELETE_CHEMICAL_ANALYSIS_FAILURE,
  payload: error,
});

const deleteChemicalAnalysis = (chemicalAnalysisId, udBy, jwtToken) => {
  let headers = { headers: { Authorization: `Bearer ${jwtToken}` } };

  return (dispatch) => {
    dispatch(deleteChemicalAnalysisRequest());
    let url = `${baseUrl}/dpp/chemical_analysis/delete?chemicalAnalysisId=${chemicalAnalysisId}&udBy=${udBy}`;

    return axios
      .delete(url, headers)
      .then((response) => {
        dispatch(deleteChemicalAnalysisSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(deleteChemicalAnalysisFailure(err.response));
        return { status: false, data: err.response };
      });
  };
};

// --- CREATE API ---
const createChemicalAnalysisRequest = () => ({
  type: CREATE_CHEMICAL_ANALYSIS_REQUEST,
});
const createChemicalAnalysisSuccess = (payload) => ({
  type: CREATE_CHEMICAL_ANALYSIS_SUCCESS,
  payload,
});
const createChemicalAnalysisFailure = (error) => ({
  type: CREATE_CHEMICAL_ANALYSIS_FAILURE,
  payload: error,
});

const createChemicalAnalysis = (payload, jwtToken) => {
  let headers = { headers: { Authorization: `Bearer ${jwtToken}` } };

  return (dispatch) => {
    dispatch(createChemicalAnalysisRequest());
    let url = `${baseUrl}/dpp/chemical_analysis/create`;

    return axios
      .post(url, payload, headers)
      .then((response) => {
        dispatch(createChemicalAnalysisSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(createChemicalAnalysisFailure(err.response));
        return { status: false, data: err.response };
      });
  };
};

// --- EDIT API ---
const editChemicalAnalysisRequest = () => ({
  type: EDIT_CHEMICAL_ANALYSIS_REQUEST,
});
const editChemicalAnalysisSuccess = (payload) => ({
  type: EDIT_CHEMICAL_ANALYSIS_SUCCESS,
  payload,
});
const editChemicalAnalysisFailure = (error) => ({
  type: EDIT_CHEMICAL_ANALYSIS_FAILURE,
  payload: error,
});

const editChemicalAnalysis = (payload, jwtToken) => {
  let headers = { headers: { Authorization: `Bearer ${jwtToken}` } };

  return (dispatch) => {
    dispatch(editChemicalAnalysisRequest());
    let url = `${baseUrl}/dpp/chemical_analysis/update`;

    return axios
      .put(url, payload, headers)
      .then((response) => {
        dispatch(editChemicalAnalysisSuccess(response));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(editChemicalAnalysisFailure(err.response));
        return { status: false, data: err.response };
      });
  };
};

const uploadCsvForChemicalanalysisRequest = () => ({
  type: UPLOADCSV_CHEMICAL_ANALYSIS_REQUEST,
});

const uploadCsvForChemicalanalysisSuccess = (payload) => ({
  type: UPLOADCSV_CHEMICAL_ANALYSIS_SUCCESS,
  payload: payload,
});

const uploadCsvForChemicalanalysisFailure = (error) => ({
  type: UPLOADCSV_CHEMICAL_ANALYSIS_FAILURE,
  payload: error,
});

const uploadCsvForChemicalanalysis = (payload, jwtToken) => {
  let headers = {
    headers: { Authorization: `Bearer ${jwtToken}` },
  };
  return (dispatch) => {
    dispatch(uploadCsvForChemicalanalysisRequest());
    let url = `${baseUrlFileUploadTemp}/dpp_chemical_analysis/upload`;
    return axios
      .post(url, payload, headers)
      .then((response) => {
        dispatch(uploadCsvForChemicalanalysisSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(uploadCsvForChemicalanalysisFailure(err.response));
        return { status: false, data: err.response };
      });
  };
};

export {
  editChemicalAnalysis,
  createChemicalAnalysis,
  deleteChemicalAnalysis,
  getChemicalAnalysis,
  uploadCsvForChemicalanalysis,
};
